<template>
	<div class="product-card" :class="{ isCheck: isCheck }">
		<el-checkbox :label="product.product_id">
			<br />
		</el-checkbox>
		<div class="logo">
			<el-image :src="product.product_pic">
				<template v-slot:error>
					<div class="error-bg">
						<svg class="icon" aria-hidden="true">
							<use xlink:href="#icon-chaoyongtuanlogozhanweitu"></use>
						</svg>
					</div>
				</template>
			</el-image>
			<div class="lose-hint" v-if="other_status(2, 3, 4, 5)">
				<div class="label">{{ other_status_desc[0] }}</div>
				<div class="text" v-if="other_status_desc[1]">{{ other_status_desc[1] }}</div>
			</div>
			<div class="handler">
				<div class="item" :class="{ notSelf: item.notSelf }" v-for="(item, index) in imgBtns" :key="index" @click="cardClick(item)">
					<svg class="icon" aria-hidden="true">
						<use :xlink:href="item.icon"></use>
					</svg>
					<el-tooltip :content="item.tooltipContent" placement="top" :disabled="!item.tooltipContent || item.disabledTooltip">
						<span>{{ item.label }}</span>
					</el-tooltip>
				</div>
			</div>
		</div>
		<div class="product-name">
			<platform-icon :platformId="product.platform_id"></platform-icon>
			<div class="name ellipsis" @click="skipFun" :title="product.product_name">{{ product.product_name }}</div>
			<el-tooltip :content="`商品ID：${product.third_product_id}`" placement="right">
				<div class="id">ID</div>
			</el-tooltip>
		</div>
		<div class="tag-box flex flex-align-center mt-6">
			<p class="mr-4 tag-item" v-for="(item, index) in showTagArr" :key="index">
				<el-tag>{{ item.tag_name }}</el-tag>
			</p>
			<el-popover placement="bottom" max-width="500" trigger="hover">
				<el-tag class="mr-4" v-for="(item, index) in hideTagArr" :key="index">{{ item.tag_name }}</el-tag>
				<el-tag class="mr-4" slot="reference" v-if="hideTagArr.length">+{{ hideTagArr.length }}</el-tag>
			</el-popover>
			<div></div>
			<div @click="tagDialog" v-auth="['system:shopLibray:addTag']" class="flex flex-align-center edit-tag fz-12 pointer">
				<i class="el-icon-edit"></i>
				<span class="ml-4">编辑标签</span>
			</div>
		</div>
		<div class="tags">
			<span class="tag activity-type" v-if="activityType">{{ activityType }}</span>
			<span class="tag brand" v-if="product.brand_name">{{ product.brand_name }}</span>
			<span class="tag category ellipsis" v-if="product.cate_name">{{ product.cate_name }}</span>
			<el-tooltip v-if="productTagInfo.tooltip" :content="productTagInfo.tooltip" placement="top">
				<span class="product-tag tag" :class="productTagInfo.className">{{ product.product_type_name }}</span>
			</el-tooltip>
		</div>
		<div class="price">
			<span>
				现售价
				<span class="yx-color-text-regular">¥{{ product.sale_price }}</span>
			</span>
		</div>
		<div class="shop flex flex-just-between">
			<div class="flex flex-align-center">
				<i class="iconfont icon-dianpubeifen"></i>
				<span class="ml-4 ellipsis" style="max-width: 110px">{{ product.shop_name }}</span>
				<ID-tag label="店铺ID" :id="product.shop_id" />
			</div>
			<div class="flex flex-align-center">
				<shop-score
					:apiParam="{ shopId: product.shop_id, platformId: product.platform_id, thirdProductId: product.third_product_id }"
					:shopName="product['shop_name']"
					v-if="$isDy(product.platform_id)"
				>
					<template v-slot:popover="{ shopScores }">
						<span class="ml-4 cursor-pointer" slot="popover">
							体验分
							<span class="font-bold yx-color-pure-1 ml-4">
								{{
									shopScores.shopScore
										? shopScores.shopScore
										: product.shop_scores && product.shop_scores.shop_score
										? product.shop_scores.shop_score
										: '-'
								}}
							</span>
							<i class="el-icon-arrow-right"></i>
						</span>
					</template>
				</shop-score>
				<div v-if="$isKs(product.platform_id)">
					体验分:
					<span class="font-bold yx-color-pure-1 ml-4">{{ shopScores | formatEmpty }}</span>
				</div>
			</div>
		</div>
		<div class="rate">
			<div>
				<div class="label">佣金率</div>
				<div class="num">
					<span class="fz-16">{{ product.commission_rate }}</span>
					<span>%</span>
				</div>
			</div>
			<div class="ml-16" v-if="isDrPartnerDataView && rate_status && $auth.hasPermi('system:goods:commissionPercentage')">
				<div class="flex">
					<div class="label">提成比</div>
					<el-tooltip content="仅展示推广给达人的提成比" placement="top">
						<i class="iconfont icon-a-help-circle-obangzhu-xian"></i>
					</el-tooltip>
				</div>
				<div class="num">
					<span class="fz-16">{{ product.partner_rate }}</span>
					<span>%</span>
				</div>
			</div>
			<div class="ml-16" v-if="$auth.hasPermi('system:goods-ServiceRate')">
				<div class="label">服务费率</div>
				<div class="num">
					<span class="fz-16">{{ product.service_rate }}</span>
					<span>%</span>
				</div>
			</div>
			<div class="ml-16">
				<div class="label">直播价</div>
				<div class="num">
					<span>￥</span>
					<span class="fz-16">{{ live_price[0] }}</span>
					<span v-if="live_price[1]">.{{ live_price[1] }}</span>
				</div>
			</div>
		</div>
		<div class="show-more">
			<div class="detail">
				<div class="item">
					<span class="label">推广次数：</span>
					<span class="ellipsis">{{ product.promote_num }}次</span>
				</div>
				<div class="item">
					<span class="label">推广者信息：</span>
					<span class="ellipsis">{{ product.contact_user_type_desc }}</span>
				</div>
				<div class="item">
					<span class="label">{{ zsName }}：</span>
					<span class="ellipsis">{{ product.partner_name }}</span>
				</div>
				<div class="item">
					<span class="label">推广时间：</span>
					<span class="ellipsis">{{ promotion_date }}</span>
				</div>
				<div class="item" v-if="$isPlatOr(product.platform_id, ['Dy', 'Ks'])">
					<span class="label">活动名称：</span>
					<el-tooltip :disabled="!product.activity_name" :content="product.activity_name" placement="top">
						<span class="ellipsis">{{ product.activity_name }}</span>
					</el-tooltip>
				</div>
				<div class="item" v-if="product.sample_rule.outer_product_id">
					<span class="label">申样门槛：</span>
					<el-popover placement="top-start" width="200" trigger="hover" popper-class="p-16">
						<template>
							<p v-for="item in formatSampleRulePopover(product.sample_rule, product.platform_id)" :key="item">{{ item }}</p>
						</template>
						<span slot="reference" class="ellipsis" style="width: 160px; display: inline-block">
							{{ product.sample_rule | formatSampleRule(product.platform_id) }}
						</span>
					</el-popover>
				</div>
				<div class="item">
					<span class="label">团长：</span>
					<el-tooltip placement="top" :open-delay="300">
						<div slot="content">
							<span>团长ID</span>
							<span class="ml-4">{{ product.authority_id || '-' }}</span>
							<i class="el-icon-copy-document cursor-pointer ml-4 mt-2 hover" @click="handleCopy(product.authority_id)"></i>
						</div>
						<div class="flex">
							<span>{{ product.institution_name | formatEmpty | textFormat(20) }}</span>
							<div class="tag-lable radius-4 ml-4 font-h6-regular yx-color-text-regular cursor-pointer hover">ID</div>
						</div>
					</el-tooltip>
				</div>
				<div class="item">
					<span class="label">备注：</span>
					<el-tooltip :disabled="!product.remark" :content="product.remark" placement="top">
						<span class="ellipsis">{{ product.remark }}</span>
					</el-tooltip>
				</div>
			</div>
			<div class="btns">
				<el-tooltip
					v-for="(item, index) in bottomBtns.default"
					:key="index"
					:content="item.tooltipContent || '仅上传者可修改'"
					:disabled="!item.disabledTooltip && !item.notSelf"
					placement="top"
				>
					<el-button type="primary" plain @click="cardClick(item)" :class="{ notSelf: item.notSelf }">{{ item.label }}</el-button>
				</el-tooltip>
				<div class="more" v-if="bottomBtns.more.length">
					<el-button class="moren-btn" plain type="primary">
						更多
						<i class="el-icon-arrow-down"></i>
					</el-button>
					<div class="options-wrap">
						<div class="options">
							<div class="option" v-for="(item, index) in bottomBtns.more" :key="index">
								<el-tooltip :content="item.tooltipContent || '仅上传者可修改'" :disabled="!item.disabledTooltip && !item.notSelf" placement="right">
									<el-button type="text" @click="cardClick(item)" :class="{ notSelfMore: item.notSelf }">{{ item.label }}</el-button>
								</el-tooltip>
							</div>
						</div>
						<div class="arrow"></div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import shopScore from '@/components/shopScore';
import { mapGetters, mapState } from 'vuex';
import { getSourceUrl } from '@/api/shopManage';
import { zsRoleType, PLATFORM_DY } from '@/utils/dataMap';
import { formatSampleRule, formatSampleRulePopover } from '@/modules/sample/apply/rules/filter.js';
import IDTag from '@/components/ui/IDTag';
import { copy } from '@/utils/common';
export default {
	name: 'productCard',
	components: {
		shopScore,
		IDTag,
	},
	props: {
		product: {
			type: Object,
			default: _ => ({}),
		},
		checkList: {
			type: Array,
			default: _ => [],
		},
	},
	computed: {
		...mapGetters(['isDrPartnerDataView', 'isDarenPartner']),
		...mapState(['vuex_userInfo']),
		live_price() {
			const { live_price = '0.00' } = this.product;
			return `${live_price}`.split('.');
		},
		promotion_date() {
			const { promotion_start_date = '', promotion_end_date = '' } = this.product;
			return `${promotion_start_date} - ${promotion_end_date}`;
		},
		other_status() {
			return (...other_status) => other_status.includes(this.product.other_status);
		},
		other_status_desc() {
			const { other_status_desc = '' } = this.product;
			return other_status_desc.split('-');
		},
		imgBtns() {
			return this.product.operations.filter(e => e.icon).reverse();
		},
		bottomBtns() {
			const bottomBtns = this.product.operations.filter(e => !e.icon);
			return {
				default: bottomBtns.slice(0, 2),
				more: bottomBtns.slice(2),
			};
		},
		isCheck() {
			const { checkList, product } = this;
			return checkList.includes(product.product_id);
		},
		rate_status() {
			return this.vuex_userInfo?.rate_status;
		},
		zsName() {
			return zsRoleType.name;
		},
		productTagInfo() {
			const arr = [
				{},
				{ tooltip: `来源于团队“${this.zsName}”角色，手动上传的商品`, className: 'one' },
				{ tooltip: '来源于商家，且未报名其他团长招商活动的商品', className: 'two' },
				{ tooltip: '来源于商家，且成功报名了其他团长招商活动的商品', className: 'three' },
				{ tooltip: '来源于其他团长的商品', className: 'four' },
				{ tooltip: '来源于商家，报名托管的商品', className: 'two' },
			];
			const {
				product: { product_type = '' },
			} = this;
			return arr[product_type] || {};
		},
		activityType() {
			const { activity_type = '', platform_id = '' } = this.product;
			if (platform_id == PLATFORM_DY.value) return '';
			const obj = {
				1: '普通活动',
				2: '专属活动',
			};
			return obj[activity_type];
		},
		tagArr({ product }) {
			return product.tag_arr || [];
		},
		count({ tagArr }) {
			const [obj1, obj2, ...obj3] = tagArr;
			let check1 = obj1 && obj1.tag_name.length > 5 ? 0 : 1;
			let check2 = obj2 && obj2.tag_name.length > 5 ? 0 : 1;
			return check1 || check2;
		},
		showTagArr({ tagArr, count }) {
			return tagArr.length > count ? tagArr.slice(0, count + 1) : tagArr;
		},
		hideTagArr({ tagArr, count }) {
			return tagArr.length > count ? tagArr.slice(count + 1) : [];
		},
		shopScores({ product }) {
			return product?.shop_scores?.shop_score || '';
		},
	},
	filters: {
		formatSampleRule,
	},
	methods: {
		// 保持不变
		async skipFun() {
			if (this.$isSp(this.product.platform_id)) {
				return;
			}
			const {
				product: { product_id, cooperate_id, product_url, isDarenPartner },
			} = this;
			if (isDarenPartner) return window.open(product_url);
			const { code, data: { pick_source } = {} } = await getSourceUrl({ product_id, cooperate_id });
			if (code !== 0) return;
			window.open(pick_source);
		},
		cardClick(item) {
			item.click(this.product);
		},
		tagDialog() {
			this.$emit('refresh', this.product);
		},
		formatSampleRulePopover,
		handleCopy(id) {
			copy(id);
			this.$message.success('复制成功');
		},
	},
};
</script>

<style lang="less" scoped>
.product-card {
	width: 236px;
	background-color: #fff;
	padding: 8px 8px 12px;
	border-radius: 8px;
	position: relative;
	box-sizing: border-box;
	font-size: 12px;
	white-space: nowrap;
	border-width: 1px;
	border-style: solid;
	border-color: transparent;

	.el-checkbox {
		position: absolute;
		top: 20px;
		left: 20px;
		z-index: 1;

		::v-deep .el-checkbox__input.is-checked .el-checkbox__inner {
			background-color: @color-primary;
			border-color: @color-primary;
		}

		::v-deep .el-checkbox__inner {
			width: 18px;
			height: 18px;
			border: 1px solid #e3e3e3;

			&::after {
				border-width: 3px;
				left: 5px;
			}

			&:hover {
				border-color: @color-primary;
			}
		}
	}

	.logo {
		height: 220px;
		border-radius: 4px;
		overflow: hidden;
		position: relative;

		&::after {
			content: '';
			position: absolute;
			top: 0;
			right: 0;
			left: 0;
			height: 42px;
			background: linear-gradient(180deg, rgba(0, 0, 0, 0.5) 0%, rgba(0, 0, 0, 0) 100%);
		}

		.el-image {
			width: 100%;
			height: 100%;

			::v-deep .error-bg {
				width: 100%;
				height: 100%;
				position: relative;

				.icon {
					width: 100%;
					height: 100%;
				}
			}
		}

		.lose-hint {
			position: absolute;
			top: 50%;
			left: 50%;
			transform: translate(-50%, -50%);
			width: 108px;
			height: 108px;
			border-radius: 50%;
			background-color: rgba(0, 0, 0, 0.7);
			display: flex;
			flex-direction: column;
			justify-content: center;
			align-items: center;

			.label {
				font-weight: bold;
				font-size: 14px;
				line-height: 20px;
				color: #fff;
			}

			.text {
				margin-top: 4px;
				color: rgba(255, 255, 255, 0.8);
				line-height: 16px;
			}
		}

		.alteration-hint {
			position: absolute;
			bottom: 0;
			left: 0;
			right: 0;
			height: 32px;
			line-height: 32px;
			background-color: #ffeff1;
			display: flex;
			align-items: center;
			color: #fa2d48;
		}

		.handler {
			position: absolute;
			bottom: 0;
			left: 0;
			right: 0;
			height: 32px;
			display: flex;
			opacity: 0;

			.item {
				height: 100%;
				background-color: rgba(36, 117, 255, 0.86);
				flex: 1;
				display: flex;
				justify-content: center;
				align-items: center;
				font-size: 12px;
				color: #fff;
				cursor: pointer;

				&.notSelf {
					cursor: default;

					.icon,
					span {
						opacity: 0.6;
					}
				}

				.icon {
					width: 16px;
					height: 16px;
					margin-right: 2px;
				}

				& + .item {
					border-left: 1px solid rgba(255, 255, 255, 0.2);
				}
			}
		}
	}

	.product-name {
		margin-top: 12px;
		display: flex;
		align-items: center;

		.name {
			flex: 1;
			font-weight: 600;
			font-size: 14px;
			margin-left: 4px;
			cursor: pointer;

			&:hover {
				color: @color-primary;
			}
		}

		.id {
			margin-left: 8px;
			width: 20px;
			height: 18px;
			line-height: 18px;
			text-align: center;
			border-radius: 2px;
			background-color: #f5f5f5;
			color: #666;

			&:hover {
				background-color: #e9f1ff;
				color: @color-primary;
			}
		}
	}

	.tag-box {
		/deep/ .el-tag {
			max-width: 100px;
			white-space: nowrap;
			text-overflow: ellipsis;
			overflow: hidden;
		}

		.edit-tag {
			display: inline-block;
			background-color: #f7f8fa;
			border-radius: 2px;
			padding: 0px 4px;
		}
	}

	.tags {
		margin-top: 4px;
		display: flex;
		align-items: center;

		.product-tag {
			height: 18px;
			line-height: 18px;
			padding: 0 4px;
			border-radius: 2px;
			font-size: 12px;

			&.one {
				color: #0c9f1b;
				background-color: #ecf4ed;
			}

			&.two {
				color: @color-primary;
				background-color: #ebf2fd;
			}

			&.three {
				color: #c87210;
				background-color: #fef3e7;
			}

			&.four {
				color: #333333;
				background-color: #f5f5f5;
			}
		}

		.tag {
			margin-top: 4px;
			border-radius: 2px;
			padding: 0 4px;
			height: 18px;
			line-height: 18px;

			&:not(:last-child) {
				margin-right: 4px;
			}

			&.activity-type {
				color: #2475ff;
				background-color: #ebf2fd;
			}

			&.brand {
				color: #ae6c41;
				background-color: #fff2e9;
			}

			&.category {
				color: #666;
				background-color: #f8f8f8;
			}

			&.product-tag {
				&.one {
					color: #0c9f1b;
					background-color: #ecf4ed;
				}

				&.two {
					color: #2475ff;
					background-color: #ebf2fd;
				}

				&.three {
					color: #c87210;
					background-color: #fef3e7;
				}

				&.four {
					color: #333333;
					background-color: #f5f5f5;
				}
			}
		}
	}

	.price {
		margin-top: 8px;
		color: #999;
		line-height: 16px;
	}

	.shop {
		border-top: 1px dashed #eee;
		border-bottom: 1px dashed #eee;
		height: 32px;
		line-height: 32px;
		margin-top: 8px;
		color: #999;
	}

	.rate {
		display: flex;
		margin-top: 12px;

		.label {
			color: #999;
			line-height: 16px;
		}

		.num {
			font-weight: bold;
			line-height: 22px;
			font-family: HelveticaNeue-Bold, HelveticaNeue;
			color: #333;
		}

		.iconfont {
			font-size: 14px;
			color: #999;
			margin-left: 2px;
		}
	}

	.show-more {
		// display: none;
		position: absolute;
		top: 100%;
		left: -1px;
		right: -1px;
		z-index: 9;
		background-color: #fff;
		border: 1px solid #e9f1ff;
		border-top-width: 0;
		padding: 0 8px 12px;
		border-radius: 0 0 8px 8px;
		box-shadow: 0px 6px 16px 0px rgba(25, 34, 71, 0.08);
		transform: scaleY(0);
		opacity: 0;
		transform-origin: center top;
		transition: transform 300ms cubic-bezier(0.23, 1, 0.32, 1), opacity 300ms cubic-bezier(0.23, 1, 0.32, 1);

		&::before {
			content: '';
			width: 100%;
			height: 16px;
			background-color: #fff;
			display: block;
			position: absolute;
			left: 0;
			bottom: 100%;
		}

		.detail {
			.item {
				color: #666;
				line-height: 18px;
				display: flex;

				& + .item {
					margin-top: 4px;
				}

				.label {
					display: inline-block;
					width: 70px;
					color: #999;
				}

				.ellipsis {
					flex: 1;
				}
			}
		}

		.btns {
			margin-top: 12px;
			padding-top: 12px;
			border-top: 1px dashed #eee;

			.notSelf {
				cursor: default;
				color: #bdd5ff !important;
				border-color: #bdd5ff !important;
				background-color: #fff !important;
			}

			.el-button {
				padding: 0 6px;
				height: 24px;
				line-height: 24px;
				font-size: 12px;

				& + .el-button {
					margin-left: 8px;
				}
			}

			.more {
				margin-left: 8px;
				display: inline-block;
				position: relative;

				.moren-btn {
					border-color: #a7c8ff !important;
					background: #fff !important;
				}

				.el-icon-arrow-down {
					transition: transform 300ms 300ms;
				}

				.options-wrap {
					position: absolute;
					z-index: 1;
					bottom: 100%;
					left: 50%;
					margin-bottom: 10px;
					border: 1px solid #e4e7ed;
					border-radius: 4px;
					background-color: #fff;
					box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
					transform: scaleY(0) translate(-50%);
					opacity: 0;
					transition: transform 300ms cubic-bezier(0.23, 1, 0.32, 1) 300ms, opacity 300ms cubic-bezier(0.23, 1, 0.32, 1) 300ms;
					transform-origin: center bottom;

					.options {
						padding: 6px 0;

						.option {
							padding: 4px 16px;

							.notSelfMore {
								color: #ddd;
								cursor: default;
							}

							.el-button {
								font-size: 14px;
								padding: 0;
							}

							&:hover {
								background-color: #e9f1ff;
							}
						}
					}

					.arrow {
						position: absolute;
						display: block;
						width: 0;
						height: 0;
						border-color: transparent;
						border-style: solid;
						border-width: 6px;
						filter: drop-shadow(0 2px 12px rgba(0, 0, 0, 0.03));
						left: 50%;
						transform: translateX(-50%);
						bottom: -6px;
						margin-right: 3px;
						border-bottom-width: 0;
						border-top-color: #ebeef5;

						&::after {
							content: '';
							position: absolute;
							display: block;
							width: 0;
							height: 0;
							border-color: transparent;
							border-style: solid;
							border-width: 6px;
							bottom: 1px;
							margin-left: -6px;
							border-bottom-width: 0;
							border-top-color: #fff;
						}
					}
				}

				&:hover {
					.el-icon-arrow-down {
						transform: rotateZ(-180deg);
					}

					.options-wrap {
						opacity: 1;
						transform: scaleY(1) translate(-50%);
					}
				}
			}
		}
	}

	&:hover {
		border-radius: 8px 8px 0 0;
		border-color: #e9f1ff;
		box-shadow: 0px 6px 16px 0px rgba(25, 34, 71, 0.08);

		.show-more {
			// display: block;
			opacity: 1;
			transform: scaleY(1);
		}

		.handler {
			opacity: 1;
		}
	}

	&.isCheck {
		border-color: @color-primary;

		.show-more {
			border-color: @color-primary;
		}
	}
}
.tag-lable {
	width: 17px;
	text-align: center;
	line-height: 20px;
	height: 16px;
	border-radius: 1px;
	color: @color-gy7;
	margin-left: 4px;
	background: @color-gy2;
}
</style>
